/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/token';
import '../../../bills/refund_v3';
import '../../../bills/tender';
import '../../../common/currency';
import './users';
import '../../../bills/types';
import './payment';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "models": {
                    "nested": {
                      "BeemoRefundV3": {
                        "fields": {
                          "tokenPair": {
                            "type": ".squareup.common.token.TokenPair",
                            "id": 1,
                            "rule": "optional"
                          },
                          "state": {
                            "type": ".squareup.bills.Refund.State",
                            "id": 2,
                            "rule": "optional"
                          },
                          "linkedBillServerToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "linkedBillOrderReferenceId": {
                            "type": "string",
                            "id": 18,
                            "rule": "optional"
                          },
                          "linkedTenderServerToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "readOnlyLinkedTenderType": {
                            "type": ".squareup.bills.Tender.Type",
                            "id": 5,
                            "rule": "optional"
                          },
                          "refundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "creatorDetails": {
                            "type": ".squareup.beemo.api.v2.models.CreatorDetails",
                            "id": 7,
                            "rule": "optional"
                          },
                          "reason": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "clientDetails": {
                            "type": ".squareup.beemo.api.v2.models.ClientDetails",
                            "id": 9,
                            "rule": "optional"
                          },
                          "requestedAt": {
                            "type": ".squareup.bills.DatePair",
                            "id": 10,
                            "rule": "optional"
                          },
                          "refundedReportingAmounts": {
                            "type": ".squareup.bills.Tender.Amounts.ReportingAmounts",
                            "id": 11,
                            "rule": "optional"
                          },
                          "linkedTender": {
                            "type": ".squareup.beemo.api.v2.models.Tender",
                            "id": 12,
                            "rule": "optional"
                          },
                          "settlementDetails": {
                            "type": ".squareup.bills.Refund.SettlementDetails",
                            "id": 13,
                            "rule": "optional"
                          },
                          "destination": {
                            "type": ".squareup.bills.Refund.Destination",
                            "id": 14,
                            "rule": "optional"
                          },
                          "refundedAt": {
                            "type": ".squareup.bills.ISO8601Date",
                            "id": 15,
                            "rule": "optional"
                          },
                          "linkedCreatorDetails": {
                            "type": ".squareup.beemo.api.v2.models.CreatorDetails",
                            "id": 16,
                            "rule": "optional"
                          },
                          "refundType": {
                            "type": ".squareup.bills.Refund.RefundType",
                            "id": 17,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.BeemoRefundV3) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BeemoRefundV3 @ squareup/beemo/v2/models/refund_v3.proto at 14:1
 */
export const BeemoRefundV3 = $root.lookupType('squareup.beemo.api.v2.models.BeemoRefundV3');
fixType(BeemoRefundV3);
Builder.createAndAttachToType(BeemoRefundV3);